/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { Textarea } from '@mantine/core';
import InputText from 'primitives/InputText/InputText';

import { NON_REQUIRED_FIELDS } from 'constants/menuManagement';

export default function StringField({
  form,
  title,
  disabledDueToLinkedMerchants = false,
  dataIndex,
}) {
  const isRequired = !NON_REQUIRED_FIELDS.includes(dataIndex);
  const formattedTitle = `${title}${isRequired ? ' *' : ''}`;

  const inputProps = form.getInputProps(dataIndex);

  if (title === 'Description') {
    return (
      <Textarea
        label={formattedTitle}
        disabled={disabledDueToLinkedMerchants || dataIndex === 'itemId'}
        autosize
        minRows={3}
        variant="wide"
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...inputProps}
      />
    );
  }

  return (
    <InputText
      label={formattedTitle}
      disabled={disabledDueToLinkedMerchants || dataIndex === 'itemId'}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...inputProps}
    />
  );
}

StringField.propTypes = {
  form: PropTypes.object.isRequired,
  record: PropTypes.object,
  title: PropTypes.string,
  disabledDueToLinkedMerchants: PropTypes.bool,
  dataIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
